const getFileExtension = (fileNameOrUrl: string): string => {
  const normalized = fileNameOrUrl.toLowerCase().replace(/%2e/g, '.');

  const lastDotIndex = normalized.lastIndexOf('.');
  if (lastDotIndex === -1) return '';

  return normalized.substring(lastDotIndex + 1).split(/[?&#]/)[0];
};


export default getFileExtension;
